import { Box, Container, Grid, Skeleton, styled } from '@mui/material';
import SkeletonFeed from './SkeletonFeed';

const CustomSkeleton = styled(Skeleton)(() => ({
  boxShadow: 'none',
  textAlign: 'center',
  height: 238,
  borderRadius: 20
}));

export function SkeletonDashboardFeed() {
  return (
    <Container>
      <Grid container spacing={3}>
        <Grid
          item
          md={8}
          xs={12}
          pr={{
            sm: 3
          }}
          mb={{
            sm: 3
          }}
        >
          <CustomSkeleton variant="rectangular" />
          <Box mt={3}>
            <SkeletonFeed />
          </Box>
          <Box mt={3}>
            <SkeletonFeed />
          </Box>
          <Box mt={3}>
            <SkeletonFeed />
          </Box>
        </Grid>
        <Grid
          item
          md={4}
          xs={12}
          sx={{ position: 'sticky !important', alignSelf: 'flex-start !important', top: 0 }}
        >
          {/* <CustomSkeleton variant="rectangular" /> */}
          <Grid container spacing={1}>
            {[0, 1].map((_, index) => (
              <Grid item key={index} xs={12} sm={6}>
                <Skeleton variant="rounded" height={200} />
              </Grid>
            ))}
          </Grid>
          {/* <Box mt={3}>
            <CustomSkeleton variant="rectangular" />
          </Box> */}
        </Grid>
      </Grid>
    </Container>
  );
}
